/*
  전역 fetch 유틸 / Global fetch utilities
  ------------------------------------------------------------------
  목적 / Purpose:
  마켓 교차 도메인 리다이렉트나 봇 챌린지가 JSON/섹션 대신 HTML을
  돌려줄 때, .json() · DOMParser().getElementById(...) 가 throw/널 참조로
  깨지는 연쇄를 막는다.
  Guard against redirect / bot-challenge HTML coming back where JSON or
  a section render was expected, which otherwise breaks .json() and the
  DOMParser getElementById(...) cascade.
*/

// JSON 응답을 안전하게 파싱 / Safely parse a JSON response.
// 주의: !res.ok 만으로 중단하지 않는다 — Shopify cart API 는 422 등에서도
// JSON 바디(response.status / errors)를 돌려주고 호출부가 이를 검사한다.
// 오직 content-type 이 JSON 이 아닐 때(리다이렉트 HTML 등)만 null 반환.
// Note: do NOT bail on !res.ok alone — the Shopify cart API returns a JSON
// body (status / errors) on 422 etc. that callers inspect. Only bail (null)
// when the content-type is not JSON (e.g. redirect HTML).
window.fetchJsonSafe = async function (url, options) {
  const res = await fetch(url, options);

  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) return null; // HTML/리다이렉트면 중단 / bail on non-JSON

  try {
    return await res.json();
  } catch (e) {
    return null; // 깨진 JSON 이면 중단 / bail on malformed JSON
  }
};

// 섹션 렌더링(HTML) 응답을 안전하게 파싱 / Safely fetch a Section Rendering (HTML) response.
// ?section_id= / ?view= 처럼 HTML 을 돌려주는 엔드포인트용.
// 비정상 응답이면 null 을 반환해 호출부가 조용히 빠져나가게 한다.
// For endpoints that return HTML; returns null on a non-OK response so the
// caller can bail silently instead of parsing a redirect page.
window.fetchTextSafe = async function (url, options) {
  const res = await fetch(url, options);
  if (!res.ok) return null; // 비정상 응답이면 중단 / bail on non-OK
  return res.text();
};
